import { Dictionary } from '@types';
import {IToothPosition} from '@data/models/TreatmentPlan';

export enum ToothMovementPoints {
  CenterOfResistance = 'centerOfResistance',
  CrownCenter = 'crownCenter',
  CrownTip = 'crownTip',
  RootTip = 'rootTip',
  HingeMesial = 'hingeMesial',
  HingeDistal = 'hingeDistal'
}

export enum MovementType {
  MesialDistalTranslation = 'mesialDistalTranslation',
  BuccalLingualTranslation = 'buccalLingualTranslation',
  ExtrusionIntrusionTranslation = 'extrusionIntrusionTranslation',
  AxialRotation = 'axialRotationDeg',
  MesialDistalAngulation = 'mesialDistalAngulationDeg',
  BuccalLingualAngulation = 'buccalLingualAngulationDeg'
}

export enum LimitProperty {
  MesialDistalTranslationMin = 'mesialDistalTranslationMinMm',
  MesialDistalTranslationMax = 'mesialDistalTranslationMaxMm',
  BuccalLingualTranslationMin = 'buccalLingualTranslationMinMm',
  BuccalLingualTranslationMax = 'buccalLingualTranslationMaxMm',
  ExtrusionIntrusionMin = 'extrusionIntrusionMinMm',
  ExtrusionIntrusionMax = 'extrusionIntrusionMaxMm',
  BuccalLingualTorqueMin = 'buccalLingualTorqueMinAngleDegrees',
  BuccalLingualTorqueMax = 'buccalLingualTorqueMaxAngleDegrees',
  AxialRotationMin = 'axialRotationMinAngleDegrees',
  AxialRotationMax = 'axialRotationMaxAngleDegrees',
  MesialDistalAngulationMin = 'mesialDistalAngulationMinAngleDegrees',
  MesialDistalAngulationMax = 'mesialDistalAngulationMaxAngleDegrees'
}

export interface IToothMovement {
  axialRotationDeg: number;
  buccalLingualAngulationDeg: number;
  buccalLingualTranslation: number;
  extrusionIntrusionTranslation: number;
  mesialDistalAngulationDeg: number;
  mesialDistalTranslation: number;
}


export interface IMovementLimits {
  mesialDistalTranslationMinMm: number;
  mesialDistalTranslationMaxMm: number;
  buccalLingualTranslationMinMm: number;
  buccalLingualTranslationMaxMm: number;
  extrusionIntrusionMinMm: number;
  extrusionIntrusionMaxMm: number;
  buccalLingualTorqueMinAngleDegrees: number;
  buccalLingualTorqueMaxAngleDegrees: number;
  axialRotationMinAngleDegrees: number;
  axialRotationMaxAngleDegrees: number;
  mesialDistalAngulationMinAngleDegrees: number;
  mesialDistalAngulationMaxAngleDegrees: number;
}

export interface IToothMovementLimits {
  primaryLimits: IMovementLimits;
  secondaryLimits?: IMovementLimits;
  tertiaryLimits?: IMovementLimits;
}


export type IToothMovementDisplacementPerToothOriginPositions = {
    [key in ToothMovementPoints]: IToothMovement;
};

export interface IToothPositionMovement {
  toothLabel?: string;
  toothPosition?: IToothPosition;
  toothMovement: IToothMovement;
  displacementPerToothOriginPositions?: IToothMovementDisplacementPerToothOriginPositions;
}

// Movement data for one stage, key is tooth id, value is movement data for tooth
export type TeethMovementStage = Dictionary<IToothPositionMovement[]>;

// All movement data
export type TeethMovementData = Dictionary<TeethMovementStage>;
